import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { loanSignMock } from './mocks/loan-sign.mock';
var apiUrl = env.VITE_API_URL;
export var loanSignHandler = [
    http.post("".concat(apiUrl, "/loan/sign"), function () {
        return HttpResponse.json(loanSignMock.success);
    }),
];
